import { render, staticRenderFns } from "./LojaEdicao.vue?vue&type=template&id=37f829d8&scoped=true"
import script from "./LojaEdicao.vue?vue&type=script&lang=js"
export * from "./LojaEdicao.vue?vue&type=script&lang=js"
import style0 from "./LojaEdicao.vue?vue&type=style&index=0&id=37f829d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f829d8",
  null
  
)

export default component.exports